/*
 * Acceptation des CGV dans le panier (tiroir + page panier).
 * - Mémorise l'acceptation pendant la session (sessionStorage).
 * - Synchronise toutes les cases présentes sur la page.
 * - Enregistre la date d'acceptation dans l'attribut de panier « CGV acceptées ».
 * - Bloque les boutons de paiement express tant que la case n'est pas cochée.
 * - Réapplique l'état après chaque re-rendu du tiroir.
 */
(function () {
  if (window.__cgvCartInit) return;
  window.__cgvCartInit = true;

  var STORAGE_KEY = 'cgv_accepted';
  var ATTRIBUTE_KEY = 'CGV acceptées';
  var INPUT_SELECTOR = '.cart__cgv-input';
  var HIDDEN_SELECTOR = '.cart__cgv-attribute';
  var EXPRESS_SELECTOR = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons';

  function getStoredDate() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function remember(date) {
    try {
      if (date) {
        sessionStorage.setItem(STORAGE_KEY, date);
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {
      /* sessionStorage indisponible : on continue sans persistance */
    }
  }

  function checkboxes() {
    return document.querySelectorAll(INPUT_SELECTOR);
  }

  function nowString() {
    return new Date().toLocaleString('fr-FR');
  }

  function reflectState(accepted, date) {
    checkboxes().forEach(function (cb) {
      cb.checked = accepted;
    });
    document.querySelectorAll(HIDDEN_SELECTOR).forEach(function (input) {
      input.value = accepted ? date : '';
    });
    document.querySelectorAll(EXPRESS_SELECTOR).forEach(function (el) {
      el.classList.toggle('cgv-locked', !accepted);
    });
  }

  function saveAttribute(value) {
    if (!window.routes || !window.routes.cart_update_url) return;
    var attributes = {};
    attributes[ATTRIBUTE_KEY] = value;
    fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches(INPUT_SELECTOR)) return;

    var accepted = target.checked;
    var date = accepted ? nowString() : '';

    remember(accepted ? date : null);
    reflectState(accepted, date);
    saveAttribute(date);
  });

  function restore() {
    if (!checkboxes().length) return;
    var date = getStoredDate();
    reflectState(Boolean(date), date || '');
  }

  function start() {
    restore();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(restore).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
